import { ISegmentTypes } from "@/data/enums/segments";

import i18n from "@/i18n";

export const SegmentTypesMap = () => {
  return [
    {
      value: ISegmentTypes.CLIENT,
      label: i18n.t("_.clients").toString()
    },
    {
      value: ISegmentTypes.CONTRACTS_PRODUCTS,
      label: i18n.t("_.products").toString()
    },
    {
      value: ISegmentTypes.CONTRACTS_PRODUCTS_SALE,
      label: i18n.t("_.sales").toString()
    },
    {
      value: ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION,
      label: i18n.t("_.subscriptions").toString()
    },
    {
      value: ISegmentTypes.ORDER,
      label: i18n.t("_.orders").toString()
    }
  ];
};
